<script setup>
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  hideToggle: {
    type: Boolean,
    default: false,
  },
});

const modelValue = defineModel({ type: Boolean, default: false });
</script>

<template>
  <div
    class="flex flex-col items-start overflow-hidden border border-n-weak bg-n-alpha-1 rounded-2xl shadow-sm [interpolate-size:allow-keywords]"
  >
    <div class="flex flex-col gap-1.5 items-start w-full px-5 py-4 sm:px-6">
      <div class="flex items-center gap-3 w-full justify-between">
        <span class="text-heading-3 text-n-slate-12">
          {{ header }}
        </span>
        <template v-if="hideToggle">
          <slot name="hiddenToggle">
            <div class="size-2" />
          </slot>
        </template>
        <ToggleSwitch v-else v-model="modelValue" />
      </div>
      <span
        v-if="description"
        class="max-w-4xl text-body-small text-n-slate-11"
      >
        {{ description }}
      </span>
      <slot />
    </div>
    <div
      v-if="$slots.editor"
      class="w-full border-t border-n-weak bg-n-background"
      :class="{ 'p-0': compact, 'px-5 pb-5 pt-3 sm:px-6': !compact }"
    >
      <slot name="editor" />
    </div>
  </div>
</template>
